// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"67b1ebfc","207":"67b1ebfc","274":"4c34902b","474":"6b4debd1","634":"67b1ebfc","832":"e8103b94"}[chunkId] + ".chunk.css";
};